import { render } from "./SldDiy.vue?vue&type=template&id=1226deae&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=1226deae&lang=scss&scoped=true"
import "./SldDiy.vue?vue&type=style&index=1&id=1226deae&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1226deae"]])

export default __exports__